// extracted by mini-css-extract-plugin
module.exports = {"errorArea":"Error_errorArea__gYv29"};